import axios from "axios";
import { APIUrl } from "./config.js";
import { readItem } from "./storage.js";

// Ein Client fuer alle API-Aufrufe. Base-URL aus .env, Bearer aus dem Cookie
// bei jedem Aufruf frisch (nach Login/Logout aendert er sich), JSON hin und
// zurueck. Antworten der API haben die Form { status, status_code?, data }.
export const api = axios.create({
    baseURL: APIUrl,
    timeout: 30000,
    headers: { Accept: "application/json" }
});

api.interceptors.request.use((config) => {
    const token = readItem("bearer", "cookie");
    if (token) config.headers.Authorization = "Bearer " + token;
    return config;
});

// 401 = Session serverseitig weg: zentral behandeln (session.js), der
// aufrufenden Seite trotzdem den Fehler geben, damit sie nicht weitermacht.
let unauthorizedHandler = null;
export function onUnauthorized(handler) {
    unauthorizedHandler = handler;
}
api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err?.response?.status === 401 && unauthorizedHandler) unauthorizedHandler(err);
        return Promise.reject(err);
    }
);

/** true, wenn die API den Aufruf als gelungen meldet ("true" oder true). */
export function ok(body) {
    return body?.status === true || body?.status === "true";
}

/**
 * Altes app.request-Interface (Framework7 <= 8.0) ueber axios nachgebildet:
 * get(url, params) / post(url, data), aufgeloest mit { data: <JSON-String> },
 * weil die Seiten JSON.parse(res.data) machen. Wird mit dem Umbau der Seiten
 * auf `api` ueberfluessig.
 */
export const legacyRequest = {
    get: (url, params) => api.get(url, { params }).then(toLegacy),
    post: (url, data) => api.post(url, data).then(toLegacy),
    setup() {}
};

function toLegacy(res) {
    return {
        data: typeof res.data === "string" ? res.data : JSON.stringify(res.data),
        status: res.status,
        xhr: null
    };
}
